import { pluralise, UnreachableError } from 'base/helpers';
import { Tooltip } from 'base/ui/tooltip';
import { TextTinyLight } from 'base/ui/typography';
import { FontFamilyMetadata } from 'blocks/blocks_service';
import { SegmentedFooter } from 'blocks/editor/styleguide/ui';
import React from 'react';
import styles from './FontMeta.css';

type PriceDisplayMode = 'none' | 'full' | 'simple';
export const FontMetaInfo = ({
  fontFamily,
  priceDisplayMode,
}: {
  fontFamily: FontFamilyMetadata;
  priceDisplayMode: PriceDisplayMode;
}) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const minPrice = React.useMemo(() => {
    if (fontFamily.source === 'G') {
      return 0;
    }
    const prices = fontFamily.fontFaces
      .map((face) => Number(face.price))
      .filter((price) => !isNaN(price));

    return prices.length > 0 ? Math.min(...prices) : 0;
  }, [fontFamily]);
  const renderPrice = () => {
    switch (priceDisplayMode) {
      case 'none': {
        return null;
      }
      case 'full': {
        return (
          <div style={{ display: 'flex', flexShrink: 1 }}>
            <TextTinyLight color="grey" lineClamp={1}>
              {fontFamily.source === 'G'
                ? 'Free'
                : `From $${minPrice} per style`}
            </TextTinyLight>
          </div>
        );
      }
      case 'simple': {
        if (fontFamily.source === 'G') {
          return null;
        }

        return (
          <div className={styles.priceContainer} ref={ref}>
            <TextTinyLight color="grey" lineClamp={1}>
              $
            </TextTinyLight>
            <Tooltip
              anchorRef={ref}
              placement="vertical"
              label={`From $${minPrice} per style`}
            />
          </div>
        );
      }
      default: {
        throw new UnreachableError(priceDisplayMode);
      }
    }
  };
  return (
    <SegmentedFooter>
      <div className={styles.fontFaceContainer}>
        <TextTinyLight color="grey" lineClamp={1}>
          {fontFamily.fontFaces.length}{' '}
          {pluralise(fontFamily.fontFaces.length, 'style')}
        </TextTinyLight>
      </div>
      {renderPrice()}
    </SegmentedFooter>
  );
};
